/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';

/**
 * Earnings summary for a credit card
 * @export
 * @interface CreditCardEarnings
 */
export interface CreditCardEarnings {
    /**
     * The name of the credit card product
     * @type {string}
     * @memberof CreditCardEarnings
     */
    creditCardProductName: string;
    /**
     * The multiplier for the credit card
     * @type {number}
     * @memberof CreditCardEarnings
     */
    multiplier?: number;
    /**
     * The earnings percentage for the credit card
     * @type {number}
     * @memberof CreditCardEarnings
     */
    earningsPercentage?: number;
    /**
     * The last four digits of the credit card
     * @type {string}
     * @memberof CreditCardEarnings
     */
    lastFour?: string;
    /**
     * 
     * @type {PointsAmount}
     * @memberof CreditCardEarnings
     */
    pointsAmount?: PointsAmount;
}

/**
 * Check if a given object implements the CreditCardEarnings interface.
 */
export function instanceOfCreditCardEarnings(value: object): value is CreditCardEarnings {
    if (!('creditCardProductName' in value) || value['creditCardProductName'] === undefined) return false;
    return true;
}

export function CreditCardEarningsFromJSON(json: any): CreditCardEarnings {
    return CreditCardEarningsFromJSONTyped(json, false);
}

export function CreditCardEarningsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardEarnings {
    if (json == null) {
        return json;
    }
    return {
        
        'creditCardProductName': json['credit_card_product_name'],
        'multiplier': json['multiplier'] == null ? undefined : json['multiplier'],
        'earningsPercentage': json['earnings_percentage'] == null ? undefined : json['earnings_percentage'],
        'lastFour': json['last_four'] == null ? undefined : json['last_four'],
        'pointsAmount': json['points_amount'] == null ? undefined : PointsAmountFromJSON(json['points_amount']),
    };
}

export function CreditCardEarningsToJSON(json: any): CreditCardEarnings {
    return CreditCardEarningsToJSONTyped(json, false);
}

export function CreditCardEarningsToJSONTyped(value?: CreditCardEarnings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credit_card_product_name': value['creditCardProductName'],
        'multiplier': value['multiplier'],
        'earnings_percentage': value['earningsPercentage'],
        'last_four': value['lastFour'],
        'points_amount': PointsAmountToJSON(value['pointsAmount']),
    };
}

